import React from 'react'
import PropTypes from 'prop-types'
import { useController, useFormContext } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { akTargetGroups } from 'ak_business_constants'

import Field from './Field'

const TargetGroupRadios = ({ options, control, name, rules }) => {
  const {
    field,
    fieldState: {
      invalid,
      error,
    }
  } = useController({ name, control, rules })

  const labelledOptions = akTargetGroups.filter(({ id }) => {
    return options.includes(id)
  })

  /*
     In case there is only one option for target group
     just show it

     see: given CRM OrganisationConfiguration Target Groups
   */
  if (options.length === 1) {
    return (
      <React.Fragment>
        <Form.Control type='hidden' {...field} value={labelledOptions[0].id} />
        <div className='form-control-plaintext'>{labelledOptions[0].name}</div>
      </React.Fragment>
    )
  } else {
    return (
      <>
      <Form.Group>
        {labelledOptions.map((group, index) => (
          <Form.Check
            key={`target-group-${index}`}
            {...field}
            inline
            type='radio'
            id={`target_group${index}`}
            label={group.name}
            value={group.id}
            isInvalid={invalid}
          />
        ))}
      </Form.Group>
      {error && (<span className='text-danger small'>{error.message}</span>)}
      </>
    )
  }
  
}

TargetGroupRadios.propTypes = {
  options: PropTypes.array.isRequired,
  control: PropTypes.any,
  name: PropTypes.string.isRequired,
  rules: PropTypes.any,
}

const SprOrgSpecificFields = ({ available_target_groups }) => {
  const { register, control, formState: { errors } } = useFormContext()

  return (
    <React.Fragment>
      <Form.Group className='field-birth-year field-lead' controlId='birth_year'>
        <Form.Label>Geburtsjahr * (Reisende)</Form.Label>
        <Field name='birth_year' />
      </Form.Group>

      <Form.Group className='field-target-group field-catalog' controlId='target_group'>
        <Form.Label>
          Sprachreisen für *
        </Form.Label>
        <TargetGroupRadios
          control={control}
          name='target_group'
          options={available_target_groups}
        />
      </Form.Group>
    </React.Fragment>
  )
}

SprOrgSpecificFields.propTypes = {
  available_target_groups: PropTypes.array.isRequired,
}

export default SprOrgSpecificFields
